import { Skeleton, SkeletonText, SkeletonCircle } from "@chakra-ui/react";

import styles from "./UnitCard.module.css";

export const UnitCardSkeleton = () => {
  return (
    <div className={styles.card}>
      <div className={styles.singleImageWrapper}>
        <Skeleton
          height="100%"
          width="100%"
          borderRadius="md"
          css={{
            "--start-color": "var(--color-stone-200)",
            "--end-color": "var(--color-stone-300)",
          }}
        />
      </div>
      <div className={styles.topLeftTags}>
        <div className={styles.tagsRow}>
          {[1, 2, 3].map((_, i) => (
            <Skeleton
              key={i}
              height="20px"
              width="60px"
              borderRadius="full"
              mr={2}
              css={{
                "--start-color": "var(--color-stone-300)",
                "--end-color": "var(--color-stone-400)",
              }}
            />
          ))}
        </div>
      </div>
      <button className={styles.favoriteBtn}>
        <SkeletonCircle size="6" />
      </button>
      <div className={styles.bottomInfo}>
        <div className={styles.blurGradient}>
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className={styles.titleRow}>
          <Skeleton
            height="20px"
            width="40%"
            mb={2}
            css={{
              "--start-color": "var(--color-stone-300)",
              "--end-color": "var(--color-stone-400)",
            }}
          />
          <Skeleton
            height="20px"
            width="70px"
            css={{
              "--start-color": "var(--color-stone-300)",
              "--end-color": "var(--color-stone-400)",
            }}
          />
        </div>
        <SkeletonText mt="2" lineClamp={1} />
      </div>
    </div>
  );
};
